import React from "react";

import fullstack from "../img/fullstack-icon.jpg";

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

export default class TimeLine extends React.Component {

    render() {
        return (

            <div id="TimeLine-Exp/Educ" className="container-fluid bg-light mt-5" >
            <VerticalTimeline>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
           //   contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
             contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
              date="2017 - present"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              //icon={<WorkIcon />}
            >
              <h4 className="vertical-timeline-element-title">Full-Stack JS Developer (NodeJS,React)</h4>
              <h4 className="vertical-timeline-element-subtitle">Freelence</h4>
              <p>
                - Back-end Developer  : (Nodejs : ExpressJS  - NestJS) <br/>
                - Database Mangement  : (MongoDB - MySql - GraphQL ) <br/>
                - Frent-end Developer : (Material UI , MDB , Ant Design - Bootstrap)
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2015 - 2016"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              //icon={<WorkIcon />}
            >
              <h3 className="vertical-timeline-element-title">Symfony Developer</h3>
              <h4 className="vertical-timeline-element-subtitle">Web-Solution</h4>
              <p>
               - CSV import / export module (Symfony 2) <br/>
               - REST API development 
              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2013 - 2015"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
             // icon={<WorkIcon />}
            >
              <h3 className="vertical-timeline-element-title">Web Designer</h3>
              <h4 className="vertical-timeline-element-subtitle">Web Solution</h4>
              <p>
                - Cutting the models and optimizing the graphic elements (photos, pictograms, etc.)
transmitted by the webdesigners ,using the appropriate development languages: HTML,
CSS, Javascript... 


              </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2012 - 2013"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
           //   icon={<WorkIcon />}
            >
              <h3 className="vertical-timeline-element-title">Graduation (Bachelor's Degree)</h3>
              <h4 className="vertical-timeline-element-subtitle">ISITCOM</h4>
              <p>
               Graduation project : <br/>
               Creation a Website for the ISITCOM Institute (with Symfony 2 Frameworks)

              </p>
            </VerticalTimelineElement>
            
          </VerticalTimeline>
          </div>

        );
    }
}

